import { Component, Input, OnInit } from '@angular/core';
import { NotificationMessage, NotificationViewMode } from '../notifications.model';
import { ToastNotificationsModel } from './toast-notifications.model';
import { ToastNotificationsService } from './toast-notifications.service';

@Component({
  selector: 'oir-toast-notifications',
  templateUrl: './toast-notifications.component.html',
  styleUrls: ['./toast-notifications.component.less']
})
export class ToastNotificationsComponent implements OnInit {
  @Input() mode: NotificationViewMode = NotificationViewMode.STANDARD;

  public model: ToastNotificationsModel;
  public NotificationViewMode = NotificationViewMode;

  constructor(private toastNotificationsService: ToastNotificationsService) {
    this.model = {
      items: [],
      moduleName: ''
    };
  }

  ngOnInit(): void {
    this.toastNotificationsService.toasts.subscribe(model => {
      this.model = model;
    });
  }

  public dismiss(message: NotificationMessage): void {
    this.toastNotificationsService.dismiss(message);
  }

  public isCurrentMode(modeToCheck: NotificationViewMode): boolean {
    return this.mode === modeToCheck;
  }

  public checkActionKeyPress(keyPressEvent: KeyboardEvent): boolean {
    return (keyPressEvent.code === 'Enter' || keyPressEvent.code === 'Space');
  }
}
